export enum NameSuffix {
  JR = 'JR',
  III = 'III',
  IV = 'IV',
  V = 'V',
}
